import { rest } from '@xolv-mybrightlink/common';
import { PlaceAutoCompleteResult, PlaceData } from '../model/Places';

type LocationTypeaheadResult = {
  description: string;
  place_id: string;
};

export const placeAutoComplete = async (
  input: string,
): Promise<PlaceAutoCompleteResult[]> => {
  const response = await rest.get<LocationTypeaheadResult[]>(
    `/gg/places/auto-complete?input=${input}`,
  );
  return (response.data ?? []).map((item) => ({
    description: item.description,
    placeId: item.place_id,
  }));
};

export const reverseGeoCode = async (
  lat: number,
  lng: number,
): Promise<PlaceData | null> => {
  const response = await rest.get<PlaceDataResult | null>(
    `/gg/places/reverse-geo-code?latitude=${lat}&longitude=${lng}`,
  );

  const locationData = response.data;

  return locationData != null
    ? {
        formattedAddress: locationData.formatted_address,
        zipCode: locationData.zip_code,
        city: locationData.city,
        state: locationData.state,
        country: locationData.country,
        longitude: locationData.longitude,
        latitude: locationData.latitude,
      }
    : null;
};

type PlaceDataResult = {
  formatted_address: string;
  zip_code: string;
  city: string;
  state: string;
  country: string;
  longitude: number;
  latitude: number;
};

export const placeDetails = async (placeId: string): Promise<PlaceData> => {
  const response = await rest.get<PlaceDataResult>(`/gg/places/${placeId}`);
  const locationData = response.data;
  return {
    formattedAddress: locationData.formatted_address,
    zipCode: locationData.zip_code,
    city: locationData.city,
    state: locationData.state,
    country: locationData.country,
    longitude: locationData.longitude,
    latitude: locationData.latitude,
  };
};
